import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle } from "lucide-react";

const cities = [
  "Caracas",
  "La Guaira", 
  "Guarenas",
  "Guatire",
  "Altos Mirandinos",
  "Valencia",
  "Maracay",
  "Barquisimeto",
  "Puerto La Cruz",
  "Maracaibo",
  "Otra ciudad"
];

const services = [
  "Control de asistencia",
  "Control de acceso",
  "Videovigilancia (CCTV)",
  "Redes / WiFi",
  "Alarmas",
  "Telefonía",
  "Mantenimiento",
  "Varios servicios"
];

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    city: "",
    service: "",
    name: "",
    company: "",
    contact: ""
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Connect to backend
    console.log("Form submitted:", formData);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle className="w-8 h-8 text-primary" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          ¡Mensaje recibido!
        </h3>
        <p className="text-muted-foreground">
          Respondemos en horario laboral (lunes a viernes, 8am - 4pm).
          <br />
          Si aplica, coordinamos visita técnica según agenda.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5 max-w-full overflow-hidden">
      <div className="grid sm:grid-cols-2 gap-3 sm:gap-4">
        <div>
          <label htmlFor="city-select" className="block text-sm font-medium text-foreground mb-1.5 sm:mb-2">
            Ciudad
          </label>
          <select
            id="city-select"
            required
            value={formData.city}
            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-background border border-border rounded-xl text-foreground text-sm sm:text-base focus:outline-none focus:border-primary/50 transition-colors"
          >
            <option value="">Selecciona tu ciudad</option>
            {cities.map((city) => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="service-select" className="block text-sm font-medium text-foreground mb-1.5 sm:mb-2">
            ¿Qué necesitas?
          </label>
          <select
            id="service-select"
            required
            value={formData.service}
            onChange={(e) => setFormData({ ...formData, service: e.target.value })}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-background border border-border rounded-xl text-foreground text-sm sm:text-base focus:outline-none focus:border-primary/50 transition-colors"
          >
            <option value="">Selecciona un servicio</option>
            {services.map((service) => (
              <option key={service} value={service}>{service}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-3 sm:gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1.5 sm:mb-2">
            Nombre
          </label>
          <input
            type="text"
            required
            placeholder="Tu nombre"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-background border border-border rounded-xl text-foreground text-sm sm:text-base placeholder:text-muted-foreground focus:outline-none focus:border-primary/50 transition-colors"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-1.5 sm:mb-2">
            Empresa
          </label>
          <input
            type="text"
            placeholder="Nombre de tu empresa"
            value={formData.company}
            onChange={(e) => setFormData({ ...formData, company: e.target.value })}
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-background border border-border rounded-xl text-foreground text-sm sm:text-base placeholder:text-muted-foreground focus:outline-none focus:border-primary/50 transition-colors"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-foreground mb-1.5 sm:mb-2">
          Teléfono o Email
        </label>
        <input
          type="text"
          required
          placeholder="¿Cómo te contactamos?"
          value={formData.contact}
          onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
          className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-background border border-border rounded-xl text-foreground text-sm sm:text-base placeholder:text-muted-foreground focus:outline-none focus:border-primary/50 transition-colors"
        />
      </div>

      <Button type="submit" variant="hero" size="xl" className="w-full group">
        Evaluación sin costo esta semana
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
      </Button>

      <p className="text-xs text-muted-foreground text-center">
        Agenda sujeta a disponibilidad del equipo técnico.
      </p>
    </form>
  );
};

export default ContactForm;
